<div class="workout-tracker-layout">
  <!-- Show loading while checking auth state -->
  <div *ngIf="authLoading" class="auth-loading-container">
    <div class="auth-loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3">Checking authentication...</p>
    </div>
  </div>

  <!-- Show login form when not authenticated -->
  <div *ngIf="!authLoading && !isAuthenticated" class="login-container">
    <div class="login-card">
      <h2 class="text-center mb-4">Workout Tracker</h2>
      <p class="text-center text-muted mb-4">Sign in to track your workouts and progress</p>
      
      <button class="btn btn-primary btn-lg w-100 mb-3" (click)="signInWithGoogle()">
        <i class="fab fa-google me-2"></i>Sign in with Google
      </button>
      
      <div class="divider">
        <span>or</span>
      </div>
      
      <form #loginForm="ngForm" (ngSubmit)="handleEmailLogin(loginForm)">
        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input type="email" class="form-control" id="email" name="email" ngModel required>
        </div>
        <div class="mb-3">
          <label for="password" class="form-label">Password</label>
          <input type="password" class="form-control" id="password" name="password" ngModel required>
        </div>
        <button type="submit" class="btn btn-outline-primary w-100" [disabled]="loginForm.invalid">
          Sign In
        </button>
      </form>
      
      <div class="text-center mt-3">
        <small class="text-muted">Don't have an account? <a href="#" (click)="showSignUp = !showSignUp">Sign up</a></small>
      </div>
      
      <!-- Sign up form -->
      <div *ngIf="showSignUp" class="mt-4 pt-3 border-top">
        <h5 class="text-center mb-3">Create Account</h5>
        <form #signupForm="ngForm" (ngSubmit)="handleEmailSignup(signupForm)">
          <div class="mb-3">
            <label for="displayName" class="form-label">Name</label>
            <input type="text" class="form-control" id="displayName" name="displayName" ngModel required>
          </div>
          <div class="mb-3">
            <label for="signupEmail" class="form-label">Email</label>
            <input type="email" class="form-control" id="signupEmail" name="signupEmail" ngModel required>
          </div>
          <div class="mb-3">
            <label for="signupPassword" class="form-label">Password</label>
            <input type="password" class="form-control" id="signupPassword" name="signupPassword" ngModel required minlength="6">
          </div>
          <button type="submit" class="btn btn-success w-100" [disabled]="signupForm.invalid">
            Create Account
          </button>
        </form>
      </div>
    </div>
  </div>

  <!-- Main app content when authenticated -->
  <div class="d-flex w-100" *ngIf="!authLoading && isAuthenticated">
    <app-workout-sidebar [activeTab]="activeTab" (tabChange)="activeTab = $event"></app-workout-sidebar>
    <div class="workout-main-content">
    <ng-container *ngIf="activeTab === 'dashboard'">
      <div class="container workout-tracker-wrap">
        <div class="row">
          <div class="col">
            <div class="d-flex justify-content-between align-items-center">
              <h1>Workout Tracker</h1>
              <div class="user-actions">
                <span class="me-3" *ngIf="currentUser">Welcome, {{ currentUser.displayName || currentUser.email }}</span>
                <button class="btn btn-outline-secondary" (click)="logout()">
                  <i class="fas fa-sign-out-alt me-1"></i>Logout
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <div *ngIf="loading" class="dashboard-loading">Loading...</div>
            <ng-container *ngIf="!loading">
              <div class="dashboard-header">
                <div class="dashboard-date">{{ today | date:'fullDate' }}</div>
              </div>
              <div class="dashboard-cards">
                <div class="dashboard-card stat-card">
                  <div class="stat-label">Workouts This Week</div>
                  <div class="stat-value">{{ workoutsThisWeek }}</div>
                </div>
                <div class="dashboard-card goals-card" *ngIf="goals.length">
                  <div class="goals-title">Goals Progress</div>
                  <div *ngFor="let goal of goals" class="goal-progress">
                    <div class="goal-label">{{ goal.name }}</div>
                    <div class="goal-bar-wrap">
                      <div class="goal-bar" [style.width]="(goal.current / goal.target * 100) + '%'">
                        <span class="goal-bar-text">{{ goal.current }}/{{ goal.target }} {{ goal.unit }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dashboard-actions mt-4">
                <button class="btn btn-primary log-workout-btn" (click)="activeTab = 'workouts'">Log New Workout</button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="activeTab === 'workouts'">
      <div class="container workout-tracker-wrap">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="workout-log-section">
              <h2 class="text-center">Workout Log</h2>
              <div class="text-center mb-4">
                <button class="btn log-workout-btn" (click)="showWorkoutForm ? cancelWorkoutForm() : showWorkoutForm = true">
                  {{ showWorkoutForm ? 'Cancel' : 'Log New Workout' }}
                </button>
              </div>
              <div *ngIf="showWorkoutForm" class="workout-form-card">
          <h4 class="mb-3">{{ editingWorkoutId ? 'Edit Workout' : 'Log New Workout' }}</h4>
          <form (ngSubmit)="addWorkout()" autocomplete="off">
            <div class="row g-3">
              <div class="col-md-6">
                <label class="form-label">Workout Name *</label>
                <input type="text" class="form-control" [(ngModel)]="newWorkout.name" name="workoutName" required>
              </div>
              <div class="col-md-6">
                <!-- Date field: always visible, with label and placeholder -->
                <label class="form-label" for="workoutDate">Date *</label>
                <input type="date" class="form-control" [(ngModel)]="newWorkout.date" name="workoutDate" id="workoutDate" required [placeholder]="'YYYY-MM-DD'" [value]="newWorkout.date || (today | date:'yyyy-MM-dd')">
              </div>
            </div>
<!--            <div class="mt-3">-->
<!--              <label class="form-label">Notes</label>-->
<!--              <textarea class="form-control" [(ngModel)]="newWorkout.notes" name="workoutNotes" rows="2"></textarea>-->
<!--            </div>-->
            <div class="mt-4">
              <div class="d-flex justify-content-between align-items-center mb-2">
                <h3 class="form-label mb-0">Exercises *</h3>
                <button type="button" class="btn btn-sm shadow-toggle-btn" [class.active]="showShadows" (click)="showShadows = !showShadows">
                  <span class="material-icons">{{ showShadows ? 'visibility' : 'visibility_off' }}</span>
                  Last time
                </button>
              </div>
              <div *ngFor="let ex of newWorkout.exercises as workoutExercises; let exIdx = index; trackBy: trackByExerciseIndex" class="exercise-form-card mb-3 position-relative">
                <button type="button" class="btn btn-link text-danger exercise-delete-btn" *ngIf="editExerciseIdx === exIdx" style="font-size:1.5rem;" (click)="removeExerciseFromWorkout(exIdx)" aria-label="Remove Exercise">
                  <span class="material-icons" style="vertical-align:middle;">delete</span>
                </button>
                <div class="exercise-card-actions">
                  <button type="button" class="btn btn-link text-secondary" style="font-size:1.5rem;" [class.active]="editExerciseIdx === exIdx" (click)="toggleExerciseActions(exIdx)" aria-label="Exercise options">
                    <span class="material-icons" style="vertical-align:middle;">more_vert</span>
                  </button>
                </div>
                <div class="d-flex flex-column align-items-center mb-3">
                  <span class="fw-bold exercise-header" style="font-size:1.35rem; letter-spacing:0.02em; text-align:center; cursor: pointer;" (click)="ex.exerciseId = ''" *ngIf="ex.exerciseId">{{ getExerciseNameById(ex.exerciseId) }}</span>
                  <span class="fw-bold exercise-header" style="font-size:1.35rem; letter-spacing:0.02em; text-align:center;" *ngIf="!ex.exerciseId">Exercise {{ exIdx + 1 }}</span>
                </div>
                <div class="exercise-search-wrap" *ngIf="!ex.exerciseId">
                  <!-- Muscle group chips — shown above search bar when filter is open -->
                  <div class="muscle-filter-chips" *ngIf="exerciseFilterOpen[exIdx]">
                    <span class="muscle-chip" [class.active]="!exerciseFilterMuscle[exIdx]" (click)="setExerciseMuscleFilter(exIdx, null)">All</span>
                    <span *ngFor="let mg of muscleGroupOptions" class="muscle-chip" [class.active]="exerciseFilterMuscle[exIdx] === mg" (click)="setExerciseMuscleFilter(exIdx, mg)">{{ mg }}</span>
                  </div>
                  <!-- Search bar -->
                  <div class="exercise-search-bar">
                    <span class="search-icon material-icons">search</span>
                    <input
                      type="text"
                      class="exercise-search-input"
                      [(ngModel)]="exerciseSearchTerms[exIdx]"
                      name="exerciseSearch-{{exIdx}}"
                      placeholder="Search exercises..."
                      autocomplete="off"
                      (focus)="onExerciseSearchFocus(exIdx)"
                      (blur)="onExerciseSearchBlur(exIdx)">
                    <button
                      type="button"
                      class="filter-toggle-btn"
                      [class.active]="exerciseFilterOpen[exIdx]"
                      (click)="toggleExerciseFilter(exIdx)"
                      [title]="exerciseFilterMuscle[exIdx] ? 'Filter: ' + exerciseFilterMuscle[exIdx] : 'Filter by muscle'">
                      <span class="material-icons">filter_list</span>
                      <span class="filter-active-dot" *ngIf="exerciseFilterMuscle[exIdx]"></span>
                    </button>
                  </div>
                  <!-- Results dropdown -->
                  <div class="exercise-dropdown" *ngIf="exerciseDropdownOpen[exIdx]">
                    <div *ngFor="let e of getFilteredExercises(exIdx)" class="exercise-dropdown-item" (mousedown)="selectExercise(exIdx, e)">
                      <span class="exercise-item-name">{{ e.name }}</span>
                      <span class="exercise-item-muscles" *ngIf="e.muscleGroups?.length">{{ e.muscleGroups!.slice(0,2).join(', ') }}</span>
                    </div>
                    <div class="exercise-dropdown-empty" *ngIf="getFilteredExercises(exIdx).length === 0 && hasExactMatch(exIdx)">
                      No exercises found
                    </div>
                    <div class="exercise-dropdown-item exercise-create-item" *ngIf="exerciseSearchTerms[exIdx]?.trim() && !hasExactMatch(exIdx)" (mousedown)="createExerciseFromSearch(exIdx)">
                      <span class="material-icons" style="font-size:1rem;margin-right:6px;">add_circle_outline</span>
                      Create "{{ exerciseSearchTerms[exIdx].trim() }}"
                    </div>
                  </div>
                </div>
                <div class="mt-2">
                  <div class="d-flex align-items-baseline mb-1">
                    <label class="form-label mb-0">Sets</label>
                    <span class="last-session-label ms-2" *ngIf="showShadows && ex.exerciseId && getLastSession(ex.exerciseId) as last">
                      Last: {{ last.date + 'T00:00:00' | date:'MMM d' }}
                    </span>
                  </div>
                  <div *ngFor="let set of ex.sets; let setIdx = index" class="set-block mb-1">
                    <div class="row align-items-end">
                      <!-- reps_weight -->
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'reps_weight'">
                        <div [ngClass]="editExerciseIdx === exIdx ? 'col-4 col-md-5' : 'col-6'">
                          <label class="form-label" *ngIf="setIdx === 0" for="reps-{{exIdx}}-{{setIdx}}">Reps</label>
                          <input type="number" class="form-control" [(ngModel)]="set.reps" name="reps-{{exIdx}}-{{setIdx}}" id="reps-{{exIdx}}-{{setIdx}}" placeholder="Reps" min="0">
                        </div>
                        <div [ngClass]="editExerciseIdx === exIdx ? 'col-5 col-md-5' : 'col-6'">
                          <label class="form-label" *ngIf="setIdx === 0" for="weight-{{exIdx}}-{{setIdx}}">Weight (lbs)</label>
                          <input type="number" class="form-control" [(ngModel)]="set.weight" name="weight-{{exIdx}}-{{setIdx}}" id="weight-{{exIdx}}-{{setIdx}}" placeholder="Weight" min="0">
                        </div>
                      </ng-container>
                      <!-- reps_only -->
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'reps_only'">
                        <div [ngClass]="editExerciseIdx === exIdx ? 'col-10' : 'col-12'">
                          <label class="form-label" *ngIf="setIdx === 0" for="reps-{{exIdx}}-{{setIdx}}">Reps</label>
                          <input type="number" class="form-control" [(ngModel)]="set.reps" name="reps-{{exIdx}}-{{setIdx}}" id="reps-{{exIdx}}-{{setIdx}}" placeholder="Reps" min="0">
                        </div>
                      </ng-container>
                      <!-- duration -->
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'duration'">
                        <div [ngClass]="editExerciseIdx === exIdx ? 'col-10' : 'col-12'">
                          <label class="form-label" *ngIf="setIdx === 0" for="duration-{{exIdx}}-{{setIdx}}">Duration (min)</label>
                          <input type="number" class="form-control" [(ngModel)]="set.duration" name="duration-{{exIdx}}-{{setIdx}}" id="duration-{{exIdx}}-{{setIdx}}" placeholder="Minutes" min="0" step="0.5">
                        </div>
                      </ng-container>
                      <!-- distance_duration -->
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'distance_duration'">
                        <div [ngClass]="editExerciseIdx === exIdx ? 'col-4 col-md-5' : 'col-6'">
                          <label class="form-label" *ngIf="setIdx === 0" for="distance-{{exIdx}}-{{setIdx}}">Distance (mi)</label>
                          <input type="number" class="form-control" [(ngModel)]="set.distance" name="distance-{{exIdx}}-{{setIdx}}" id="distance-{{exIdx}}-{{setIdx}}" placeholder="Miles" min="0" step="0.01">
                        </div>
                        <div [ngClass]="editExerciseIdx === exIdx ? 'col-5 col-md-5' : 'col-6'">
                          <label class="form-label" *ngIf="setIdx === 0" for="duration-{{exIdx}}-{{setIdx}}">Duration (min)</label>
                          <input type="number" class="form-control" [(ngModel)]="set.duration" name="duration-{{exIdx}}-{{setIdx}}" id="duration-{{exIdx}}-{{setIdx}}" placeholder="Minutes" min="0" step="0.5">
                        </div>
                      </ng-container>
                      <div class="col-2 col-md-2 text-end" *ngIf="editExerciseIdx === exIdx">
                        <button type="button" class="btn btn-outline-danger btn-sm set-remove-btn" (click)="removeSetFromExercise(exIdx, setIdx)">&times;</button>
                      </div>
                    </div>
                    <div class="set-shadow-line" *ngIf="showShadows && ex.exerciseId && getShadowSet(ex.exerciseId, setIdx) as shadow">
                      <span class="set-shadow" (click)="applyShadow(exIdx, setIdx)" title="Tap to use last time's values" role="button">
                        {{ formatShadowSet(shadow, getExerciseType(ex.exerciseId)) }}
                      </span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between gap-2 my-2">
                    <button type="button" class="btn btn-outline-primary btn-sm" (click)="addSetToExercise(exIdx)">+ Add Set</button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="repeatLastSet(exIdx)" *ngIf="ex.sets.length > 0">↻ Repeat Last</button>
                  </div>
                  <input type="text" class="d-inline-block mt-1 ms-2" [(ngModel)]="ex.notes" name="exerciseNotes-{{exIdx}}" placeholder="Notes">
                </div>
              </div>
              <button type="button" class="btn btn-outline-primary btn-sm" (click)="addExerciseToWorkout()">+ Add Exercise</button>
            </div>
            <div *ngIf="workoutFormError" class="alert alert-danger mt-3">{{ workoutFormError }}</div>
            <button type="submit" class="btn log-workout-btn mt-3">{{ editingWorkoutId ? 'Update Workout' : 'Save Workout' }}</button>
          </form>
        </div>
        <app-workout-log [workoutLog]="workoutLog" (workoutSelected)="onWorkoutSelected($event)"></app-workout-log>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="activeTab === 'exercises'">
      <app-exercise-list
        [exercises]="exercises"
        (addExercise)="openAddExerciseModal(null)"
        (editExercise)="onEditExercise($event)"
        (deleteExercise)="onDeleteExercise($event)">
      </app-exercise-list>
    </ng-container>
    <ng-container *ngIf="activeTab === 'routines'">
      <div class="container workout-tracker-wrap">
        <div class="row justify-content-center">
          <div class="col-lg-10">
            <div class="workout-log-section">
              <h2 class="text-center">Routines</h2>
              <div class="text-center mb-4">
                <button class="btn log-workout-btn" (click)="showRoutineForm ? cancelRoutineForm() : openRoutineForm()">
                  {{ showRoutineForm ? 'Cancel' : 'New Routine' }}
                </button>
              </div>

              <!-- Builder -->
              <div *ngIf="showRoutineForm" class="workout-form-card">
                <h4 class="mb-3">{{ editingRoutineId ? 'Edit Routine' : 'New Routine' }}</h4>
                <label class="form-label">Routine Name *</label>
                <input type="text" class="form-control mb-3" [(ngModel)]="newRoutine.name" name="routineName" placeholder="e.g. Push Day">

                <div class="d-flex justify-content-between align-items-center mb-2">
                  <h3 class="form-label mb-0">Exercises *</h3>
                </div>

                <div *ngFor="let rex of newRoutine.exercises; let idx = index" class="exercise-form-card mb-3 position-relative">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <span class="fw-bold">{{ idx + 1 }}.</span>
                    <div class="btn-group">
                      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="moveRoutineExercise(idx, -1)" [disabled]="idx === 0" aria-label="Move up">↑</button>
                      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="moveRoutineExercise(idx, 1)" [disabled]="idx === newRoutine.exercises!.length - 1" aria-label="Move down">↓</button>
                      <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeRoutineExercise(idx)" aria-label="Remove">&times;</button>
                    </div>
                  </div>

                  <div *ngIf="rex.exerciseId" class="routine-exercise-name fw-bold" style="cursor:pointer;" (click)="rex.exerciseId = ''">
                    {{ getExerciseNameById(rex.exerciseId) }}
                  </div>

                  <div class="exercise-search-wrap" *ngIf="!rex.exerciseId">
                    <div class="muscle-filter-chips" *ngIf="routineExerciseFilterOpen[idx]">
                      <span class="muscle-chip" [class.active]="!routineExerciseFilterMuscle[idx]" (click)="setRoutineMuscleFilter(idx, null)">All</span>
                      <span *ngFor="let mg of muscleGroupOptions" class="muscle-chip" [class.active]="routineExerciseFilterMuscle[idx] === mg" (click)="setRoutineMuscleFilter(idx, mg)">{{ mg }}</span>
                    </div>
                    <div class="exercise-search-bar">
                      <span class="search-icon material-icons">search</span>
                      <input
                        type="text"
                        class="exercise-search-input"
                        [(ngModel)]="routineExerciseSearchTerms[idx]"
                        name="routineExerciseSearch-{{idx}}"
                        placeholder="Search exercises..."
                        autocomplete="off"
                        (focus)="onRoutineSearchFocus(idx)"
                        (blur)="onRoutineSearchBlur(idx)">
                      <button
                        type="button"
                        class="filter-toggle-btn"
                        [class.active]="routineExerciseFilterOpen[idx]"
                        (click)="toggleRoutineFilter(idx)"
                        [title]="routineExerciseFilterMuscle[idx] ? 'Filter: ' + routineExerciseFilterMuscle[idx] : 'Filter by muscle'">
                        <span class="material-icons">filter_list</span>
                        <span class="filter-active-dot" *ngIf="routineExerciseFilterMuscle[idx]"></span>
                      </button>
                    </div>
                    <div class="exercise-dropdown" *ngIf="routineExerciseDropdownOpen[idx]">
                      <div *ngFor="let e of getRoutineFilteredExercises(idx)" class="exercise-dropdown-item" (mousedown)="selectRoutineExercise(idx, e)">
                        <span class="exercise-item-name">{{ e.name }}</span>
                        <span class="exercise-item-muscles" *ngIf="e.muscleGroups?.length">{{ e.muscleGroups!.slice(0,2).join(', ') }}</span>
                      </div>
                      <div class="exercise-dropdown-empty" *ngIf="getRoutineFilteredExercises(idx).length === 0">
                        No exercises found
                      </div>
                    </div>
                  </div>
                </div>

                <button type="button" class="btn btn-outline-primary btn-sm" (click)="addExerciseToRoutine()">+ Add Exercise</button>
                <div *ngIf="routineFormError" class="alert alert-danger mt-3">{{ routineFormError }}</div>
                <div class="mt-3">
                  <button type="button" class="btn log-workout-btn" (click)="saveRoutine()">{{ editingRoutineId ? 'Update Routine' : 'Save Routine' }}</button>
                </div>
              </div>

              <!-- List -->
              <div *ngIf="!showRoutineForm">
                <div *ngIf="routines.length === 0" class="text-center text-muted my-4">
                  No routines yet. Create one to quickly start your favorite workouts.
                </div>
                <div *ngFor="let r of routines" class="routine-card">
                  <div class="routine-card-head">
                    <div>
                      <h5 class="routine-card-title mb-1">{{ r.name }}</h5>
                      <span class="routine-card-count">{{ r.exercises.length }} exercise{{ r.exercises.length === 1 ? '' : 's' }}</span>
                    </div>
                    <div class="btn-group">
                      <button class="btn btn-sm log-workout-btn" (click)="startWorkoutFromRoutine(r)">Start</button>
                      <button class="btn btn-sm btn-outline-secondary" (click)="openRoutineForm(r)">Edit</button>
                      <button class="btn btn-sm btn-outline-danger" (click)="deleteRoutine(r)">Delete</button>
                    </div>
                  </div>
                  <ol class="routine-exercise-list">
                    <li *ngFor="let rex of r.exercises">{{ getExerciseNameById(rex.exerciseId) }}</li>
                  </ol>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </ng-container>
    </div>
  </div>
  <!-- Add Exercise Modal -->
  <div class="modal-backdrop" *ngIf="showAddExerciseModal && isAuthenticated">
    <div class="modal-dialog-centered modal-add-exercise">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isEditingExercise ? 'Edit Exercise' : 'Add New Exercise' }}</h5>
          <button type="button" class="btn-close" (click)="closeAddExerciseModal()"></button>
        </div>
        <div class="modal-body">
          <label class="form-label">Name *</label>
          <input type="text" class="form-control mb-2" [(ngModel)]="newExercise.name" required>
          <label class="form-label">Tracking Type</label>
          <div class="btn-group w-100 mb-2 flex-wrap" role="group">
            <button
              *ngFor="let opt of trackingTypeOptions"
              type="button"
              class="btn btn-sm"
              [class.btn-primary]="newExercise.trackingType === opt.value"
              [class.btn-outline-secondary]="newExercise.trackingType !== opt.value"
              (click)="newExercise.trackingType = opt.value">
              {{ opt.label }}
            </button>
          </div>
          <label class="form-label">Description</label>
          <textarea class="form-control mb-2" [(ngModel)]="newExercise.description" rows="2"></textarea>
          <label class="form-label">Muscle Groups</label>
          <div class="muscle-group-icon-grid mb-2">
            <button type="button"
              *ngFor="let mg of muscleGroupOptions"
              class="muscle-group-btn"
              [class.active]="newExercise.muscleGroups?.includes(mg)"
              (click)="toggleMuscleGroup(mg)"
              [attr.aria-pressed]="newExercise.muscleGroups?.includes(mg)"
              [attr.title]="mg">
              <span class="muscle-group-label">{{ mg }}</span>
            </button>
          </div>
          <div *ngIf="addExerciseFormError" class="alert alert-danger mt-2">{{ addExerciseFormError }}</div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="closeAddExerciseModal()">Cancel</button>
          <button class="btn btn-primary" (click)="saveNewExercise()">{{ isEditingExercise ? 'Update' : 'Save' }}</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Workout Details Modal -->
  <div class="modal-backdrop" *ngIf="showWorkoutModal && isAuthenticated">
    <div class="modal-dialog-centered modal-workout-details">
      <div class="modal-content modal-workout-content">
        <div class="modal-header modal-workout-header">
          <h5 class="modal-title">Workout Details</h5>
          <button type="button" class="btn-close" (click)="closeWorkoutModal()" aria-label="Close"></button>
        </div>
        <div class="modal-body modal-workout-body">
          <div *ngIf="selectedWorkout">
            <div class="workout-detail-section">
              <div class="detail-row">
                <span class="detail-label">Workout:</span>
                <span class="detail-value">{{ selectedWorkout.name }}</span>
              </div>
              <div class="detail-row">
                <span class="detail-label">Date:</span>
                <span class="detail-value">{{ selectedWorkout.date | date:'fullDate' }}</span>
              </div>
              <div class="detail-row" *ngIf="selectedWorkout.notes">
                <span class="detail-label">Notes:</span>
                <span class="detail-value">{{ selectedWorkout.notes }}</span>
              </div>
            </div>
            <div class="exercises-section">
              <h6 class="exercises-title">Exercises</h6>
              <div *ngFor="let ex of selectedWorkout.exercises; let exIdx = index" class="exercise-detail-card">
                <div class="exercise-header-collapsed" (click)="toggleExerciseExpanded(exIdx)">
                  <div class="exercise-header-content">
                    <span class="exercise-name">{{ getExerciseNameById(ex.exerciseId) }}</span>
                    <span class="exercise-stats">
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'reps_weight'">
                        <span class="stat-item">Avg: {{ getAverageReps(ex.sets) }} reps &#64; {{ getAverageWeight(ex.sets) }} lbs</span>
                      </ng-container>
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'reps_only'">
                        <span class="stat-item">Avg: {{ getAverageReps(ex.sets) }} reps</span>
                      </ng-container>
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'duration'">
                        <span class="stat-item">Avg: {{ getAverageDuration(ex.sets) }} min</span>
                      </ng-container>
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'distance_duration'">
                        <span class="stat-item">Avg: {{ getAverageDistance(ex.sets) }} mi in {{ getAverageDuration(ex.sets) }} min</span>
                      </ng-container>
                    </span>
                  </div>
                  <span class="expand-icon" [class.expanded]="isExerciseExpanded(exIdx)">▼</span>
                </div>
                <div class="exercise-expanded" *ngIf="isExerciseExpanded(exIdx)">
                  <div *ngIf="ex.notes" class="exercise-notes">
                    <strong>Notes:</strong> {{ ex.notes }}
                  </div>
                  <div class="sets-list">
                    <div class="sets-label"><strong>Sets:</strong></div>
                    <div *ngFor="let set of ex.sets; let setIdx = index" class="set-row">
                      <span class="set-number">Set {{ setIdx + 1 }}:</span>
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'reps_weight'">
                        <span class="set-details">{{ set.reps }} reps &#64; {{ set.weight }} lbs</span>
                      </ng-container>
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'reps_only'">
                        <span class="set-details">{{ set.reps }} reps</span>
                      </ng-container>
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'duration'">
                        <span class="set-details">{{ set.duration }} min</span>
                      </ng-container>
                      <ng-container *ngIf="getExerciseType(ex.exerciseId) === 'distance_duration'">
                        <span class="set-details">{{ set.distance }} mi in {{ set.duration }} min</span>
                      </ng-container>
                      <span class="rest-time" *ngIf="set.restTime">(Rest: {{ set.restTime }}s)</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer modal-workout-footer">
          <button class="btn btn-secondary" (click)="closeWorkoutModal()">Close</button>
          <button class="btn btn-primary" (click)="openEditWorkout(selectedWorkout)">Edit</button>
        </div>
      </div>
    </div>
  </div>
  <div class="workout-mobile-tabbar">
    <button class="tab-btn" [class.active]="activeTab === 'dashboard'" (click)="activeTab = 'dashboard'">
      <span>🏠</span>
      <span class="tab-label">Dashboard</span>
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'workouts'" (click)="activeTab = 'workouts'">
      <span>💪</span>
      <span class="tab-label">Workouts</span>
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'exercises'" (click)="activeTab = 'exercises'">
      <span>🏋️‍♂️</span>
      <span class="tab-label">Exercises</span>
    </button>
    <button class="tab-btn" [class.active]="activeTab === 'routines'" (click)="activeTab = 'routines'">
      <span>📋</span>
      <span class="tab-label">Routines</span>
    </button>
  </div>
</div>
